module.exports = __webpack_public_path__ + "img/image-hero-2-mobile.0a3f8512.png";